import { Grid, Button, Typography,  } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { makeStyles } from '@material-ui/core';
import { history } from '../../../../../helpers';
import { routePaths } from '../../../../config/route-paths';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@material-ui/lab';


const useStyles = makeStyles((theme) => ({
    subTitle: {
        fontWeight: "bold",
        color: theme.palette.eRich.base + "!important",
    },
    linkColor: {
        color: theme.palette.ePrimary.base + "!important",
    },
    paymentHeaderSuccess: {
        color: theme.palette.eSecondary.base + "!important"
    },
    paymentHeaderError: {
        color: theme.palette.eTertiary.base
    },
    textPayment: {
        paddingLeft: "25px",
        paddingRight: "25px",
    },
    backButton: {
        color: theme.palette.ePrimary.base,
        fontWeight: "bolder",
        marginLeft: "1.563rem"
    },
    divMargin: {
        marginTop: "5px",
        marginLeft:"1.4rem"
    },
    header: {
        fontWeight: "bold",
        marginLeft: "1.563rem"
    },
    backButtonGrid: {
        width: "45px"
    },
    backIcon: {
        minWidth: "0px !important",
        width: "40px",
        padding: "0px !important"
    }
}))

export default function PaymentConfirmationHeader({ postData }) {

    const [headerStatusSubtitle, setHeaderStatusSubtitle] = useState(null);

    const classes = useStyles()
    let labels = useSelector(
        (store) => store?.labels?.data?.getLabels?.E_AUTH_PAYMENT_CONFIRMATION
    );
    const supportPhone = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.SUPPORT_CALL_PHONE_NUMBER
    );
    const supportEmail = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_SERVICE_REQUEST_CONFIRMATION_MAIL
    );
    let backClick = () => {
         history.push(routePaths.QUICK_PAY);
         localStorage.removeItem("amount");
    }
    const {t:label, ready: LabelReady} = useTranslation("label-E_NESCO_PAYMENT")
    const SUCCESS ="SUCCESS"
    const REQUEST_CANCELLED_URL ="REQUEST_CANCELLED_URL"
    const RETRY_ALLOWED ="RETRY_ALLOWED"
    const RETRY_NOT_ALLOWED ="RETRY_NOT_ALLOWED"
    const failure ="failure"
    const INTERNAL_ERROR ="INTERNAL_ERROR"
    const RETRY_NOT_ALLOWED_FAILED_C2M_API="RETRY_NOT_ALLOWED_FAILED_C2M_API"
    const cancelTitle = label("E_PAYMENT_CONFIRMATION_CANCEL_LABEL")
    
    useEffect(() => {
        if(LabelReady && postData) {
            switch (postData?.status) {
                case SUCCESS:
                    setHeaderStatusSubtitle(label('E_PAYMENT_SUBTITLE'))
                    break;
                case RETRY_ALLOWED:
                    if(postData?.statusMessage === REQUEST_CANCELLED_URL) {
                        setHeaderStatusSubtitle(label('E_PAYMENT_CANCEL'))
                    }
                    if(postData?.statusMessage !== REQUEST_CANCELLED_URL) {
                        setHeaderStatusSubtitle(label('E_PAYMENT_ERROR_CASE'))
                    }
                    break;
                case RETRY_NOT_ALLOWED:
                case INTERNAL_ERROR:
                    if(postData?.statusMessage === failure) {
                        setHeaderStatusSubtitle(label('E_PAYMENT_ERROR_CASE'))
                    }
                break;
                case RETRY_NOT_ALLOWED_FAILED_C2M_API:
                    setHeaderStatusSubtitle(label('E_PAYMENT_ERROR_CASE_C2M').replace('*supportNum*', supportPhone).replace('*supportEmail*', supportEmail))
                break;
            }
        }
    }, [LabelReady, postData])

    return (
        <>
            <Grid container direction="column">
                <Grid item xs={12} md={3} align="left">
                    <Button
                        size="small"
                        startIcon={<ArrowBackIosIcon fontSize="small" />}
                        onClick={backClick}
                        className={classes.backButton}
                    >
                        <b>{labels?.E_AUTH_PAYMENT_CONFIRMATION_BACK}</b>
                    </Button>
                </Grid>
                <Grid item className={classes.divMargin}
                >
                     {postData?.status === SUCCESS ? (<>
                        <Typography variant="h5"
                        className={
                            classes.paymentHeaderSuccess
                        }>
                        <b>   
                        {labels?.E_AUTH_PAYMENT_CONFIRMATION_SUCCESS}
                        </b>
                    </Typography>
                    </>) : null}
          {postData?.statusMessage === REQUEST_CANCELLED_URL ? (<>
            <Typography variant="h6"
            className={classes.paymentHeaderError }>
            <b>{cancelTitle}</b>
            </Typography></>) : postData?.status !== SUCCESS && (<>
                        <Typography variant="h5"
                        className={classes.paymentHeaderError}>
                        <b>{labels?.E_AUTH_PAYMENT_CONFIRMATION_ERROR}</b>
                    </Typography></>)}
                </Grid>
            </Grid>
            <Grid container
                spacing={2}
                className={classes.textPayment}
            >
                <Grid item>
                <Typography className={classes.subTitle}
                    dangerouslySetInnerHTML={{
                        __html: headerStatusSubtitle
                    }}
                >
                </Typography>
                </Grid>
            </Grid>
        </>
    )
}